/* All pages from home are imported from here */
import HomePage from "./home";

export default HomePage;
